/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Import_Close_LabelInputs */

const en_file_import_close_label = /** @type {(inputs: File_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close file import`)
};

const fr_file_import_close_label = /** @type {(inputs: File_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close file import`)
};

const de_file_import_close_label = /** @type {(inputs: File_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateiimport schließen`)
};

const it_file_import_close_label = /** @type {(inputs: File_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi importazione file`)
};

const ru_file_import_close_label = /** @type {(inputs: File_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть импорт файла`)
};

const es_file_import_close_label = /** @type {(inputs: File_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar importación de archivos`)
};

const zh_cn2_file_import_close_label = /** @type {(inputs: File_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭文件导入`)
};

const ja_file_import_close_label = /** @type {(inputs: File_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルのインポートを閉じる`)
};

const hi_file_import_close_label = /** @type {(inputs: File_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाइल आयात बंद करें`)
};

const pt_pt2_file_import_close_label = /** @type {(inputs: File_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar importação de arquivos`)
};

/**
* | output |
* | --- |
* | "Close file import" |
*
* @param {File_Import_Close_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_import_close_label = /** @type {((inputs?: File_Import_Close_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Import_Close_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_import_close_label(inputs)
	if (locale === "de") return de_file_import_close_label(inputs)
	if (locale === "it") return it_file_import_close_label(inputs)
	if (locale === "ru") return ru_file_import_close_label(inputs)
	if (locale === "es") return es_file_import_close_label(inputs)
	if (locale === "zh-CN") return zh_cn2_file_import_close_label(inputs)
	if (locale === "ja") return ja_file_import_close_label(inputs)
	if (locale === "hi") return hi_file_import_close_label(inputs)
	if (locale === "pt-PT") return pt_pt2_file_import_close_label(inputs)
	return en_file_import_close_label(inputs)
});